module.exports = __webpack_public_path__ + "img/logo-horizontal-dark-evo-play.33e6314e.png";